import { QuoteWizardQuestionResponseGraph } from './models/quoteWizardQuestionResponseGraph.model';
import { IClientStateContext } from './clientstatecontext.model';
import { ICode } from '../models/code.model';
import { ISubmission } from '../models/submission.model';
import { IPhone } from '../models/phone.model';
import { IAllLinesPolicySummary } from '../models/alllinespolicysummary.model';
import { ISubmissionResponse } from '../models/submissionResponse.model';
import { IBrand, IVertical } from '../models/models';

export class QuoteWizardViewModel {
    public firstName: string;
    public lastName: string;
    public emailAddress: string;
    public phone: IPhone;
    public clientStateContext: IClientStateContext;
    public questionResponseGraph: QuoteWizardQuestionResponseGraph;

    public verticalPromise: ng.IPromise<IVertical>;
    public brandsPromise: ng.IPromise<IBrand[]>;
    public businessTypesPromise: ng.IPromise<ICode[]>;
    public loadFinishedSubmissionPromise: ng.IPromise<ISubmission>;
    public applicablePolicies: number[];
    public phonePromise: ng.IPromise<IPhone>;
    public loadPolicySummaryPromise: ng.IPromise<IAllLinesPolicySummary>;

    public finishedSubmissionResponse: ISubmissionResponse;
    public finishedSubmission: ISubmission;
    public finishedPolicySummary: IAllLinesPolicySummary;

    public isReturningUserAfterWizardCompletion: boolean;
    public isUserOnWelcomePage: boolean;

    constructor() {
        this.questionResponseGraph = new QuoteWizardQuestionResponseGraph();
    }

}